"use strict";
var Observable_1 = require("../../Observable");
var bufferCount_1 = require("../../operator/bufferCount");
Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
//# sourceMappingURL=bufferCount.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/bufferCount.js
 ** module id = 263
 ** module chunks = 1
 **/